import React, { Component, PropTypes } from 'react';
import { SketchPicker } from 'react-color';
import ReactSparkPopover from './ReactSparkPopover';
import { Saturation } from 'react-color/lib/components/common/Saturation';
import { CustomPicker } from 'react-color';
import { debounce, get } from 'lodash';
import color from 'react-color/lib/helpers/color';
import store from '../../store/Store';
import BackgroundProperyParser from '../../../lib/css-property-parser/BackgroundProperyParser';
import ModalAssetBrowser from './ModalAssetBrowser';
import { envValue } from '../../../config/envUtils';
import { Hue } from 'react-color/lib/components/common/Hue';
import { Alpha } from 'react-color/lib/components/common/Alpha';
import { SketchPresetColors } from 'react-color/lib/components/sketch/SketchPresetColors';
import { SketchFields } from 'react-color/lib/components/sketch/SketchFields';
import ReactSparkSelectInput from './ReactSparkSelectInput';
import { Service as FileService } from '../../services/Service';
import { connect } from 'react-redux';
import { CATEGORIES } from '../../services/fileUpload/uploadFile';
import InputTextField from 'components/common/InputTextField';
const SOURCEURL = envValue('SOURCEURL');

function getContrast(hexcolor) {
    let hex = hexcolor;
    if (hex.indexOf('#') === 0) {
        hex = hex.slice(1);
    }
    const r = parseInt(hex.substr(0, 2), 16);
    const g = parseInt(hex.substr(2, 2), 16);
    const b = parseInt(hex.substr(4, 2), 16);
    const yiq = (r * 299 + g * 587 + b * 114) / 1000;
    return yiq >= 128 ? 'black' : 'white';
}

export class BackgroundPicker extends Component {
    static propTypes = {
        background: PropTypes.string,
        onChange: PropTypes.func,
        isDisabled: PropTypes.bool,
        hideImageSelector: PropTypes.bool
    };
    static defaultProps = {
        background: '',
        onChange: () => {},
        isDisabled: false,
        hideImageSelector: false
    };

    constructor(props) {
        super(props);
        this.onImageChange = this.onImageChange.bind(this);
        this.handleColorChange = this.handleColorChange.bind(this);
        this.onChange = this.onChange.bind(this);
        this.rawInput = this.rawInput.bind(this);

        this.parser = new BackgroundProperyParser(null);
        this.parser.property = props.background;

        this.state = {
            showAssetBrowser: false,
            background: this.parser.property,
            backgroundColor: { ...color.toState(BackgroundPicker.processColorProperty(this.parser), 0) },
            backgroundImage: this.parser.image[0],
            backgroundPosition: this.parser.position,
            backgroundSize: this.parser.size,
            backgroundOrigin: this.parser.origin,
            backgroundClip: this.parser.clip,
            backgroundAttachment: this.parser.attachment,
            error: this.parser.error
        };

        this.debounce = debounce((fn, data, event) => {
            fn(data, event);
        }, 100);
    }
    static processColorProperty(parser) {
        const { color: backgroundColor } = parser;
        let converted = {};
        if (backgroundColor.length === 1) {
            converted = { hex: backgroundColor[0] };
        } else if (backgroundColor.length >= 4) {
            if (backgroundColor[0] === 'hsl' || backgroundColor[0] === 'hsla') {
                converted = {
                    h: backgroundColor[1],
                    s: backgroundColor[2],
                    l: backgroundColor[3],
                    a: backgroundColor[4] || 1
                };
            } else {
                converted = {
                    r: backgroundColor[1],
                    g: backgroundColor[2],
                    b: backgroundColor[3],
                    a: backgroundColor[4] || 1
                };
            }
        }
        return converted;
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.background && nextProps !== this.parser.property) {
            this.parser.property = nextProps.background;
            this.readParser();
        }
    }
    readParser() {
        this.setState({
            background: this.parser.property,
            backgroundColor: {
                ...color.toState(
                    BackgroundPicker.processColorProperty(this.parser),
                    get(this, ['state', 'backgroundColor', 'oldHue'], 0)
                )
            },
            backgroundImage: this.parser.image[0],
            backgroundPosition: this.parser.position,
            backgroundSize: this.parser.size,
            backgroundOrigin: this.parser.origin,
            backgroundClip: this.parser.clip,
            backgroundAttachment: this.parser.attachment,
            error: this.parser.error
        });
    }
    handleSwatchHover = (data, event) => {
        const isValidColor = color.simpleCheckForValidColor(data);
        if (isValidColor) {
            const colors = color.toState(data, data.h || this.state.backgroundColor.oldHue);
            this.setState({
                backgroundColor: colors
            });
            this.props.onSwatchHover && this.props.onSwatchHover(colors, event);
        }
    };

    handleColorChange(data, event) {
        const isValidColor = color.simpleCheckForValidColor(data);
        this.parser.clearImage();
        if (isValidColor) {
            const colors = color.toState(data, data.h || this.state.backgroundColor.oldHue);
            const { r, g, b, a } = colors.rgb;
            this.parser.color = ['rgba', r, g, b, a];
            this.setState({
                backgroundColor: colors,
                showAssetBrowser: false
            });
            this.onChange(data, event);
        }
    }
    onImageChange(assets) {
        if (assets.length) {
            this.parser.image = [
                FileService.assetUrl(
                    assets[0].chainid,
                    assets[0].hotelid,
                    null,
                    this.props.level,
                    assets[0].filename,
                    false,
                    CATEGORIES.IMAGE
                )
            ];
            this.setState({
                backgroundImage: this.parser.image[0],
                showAssetBrowser: false
            });
            this.onChange();
        }
    }
    rawInput(event) {
        this.parser.property = event.target.value;
        this.setState({ showAssetBrowser: false });
        this.readParser();
    }
    onChange() {
        const newBackground = this.parser.build();
        this.props.onChangeComplete && this.debounce(this.props.onChangeComplete, newBackground);
        this.props.onChange && this.props.onChange(newBackground);
    }
    renderToggle(styles) {
        return (
            <button
                disabled={this.props.isDisabled}
                className="preset-color-picker-button"
                style={styles.image}
            ></button>
        );
    }

    render() {
        const optionalEvents = {};
        if (this.props.onSwatchHover) {
            optionalEvents.onSwatchHover = this.handleSwatchHover;
        }
        const styles = {
            image: {
                backgroundColor: `rgba(${this.state.backgroundColor.rgb.r},${this.state.backgroundColor.rgb.g},${this.state.backgroundColor.rgb.b},${this.state.backgroundColor.rgb.a})`,
                backgroundSize: 'cover',
                color: getContrast(this.state.backgroundColor.hex)
            }
        };
        if (this.state.backgroundImage) {
            styles['image']['backgroundImage'] = `url(${this.state.backgroundImage})`;
        }

        return (
            <div>
                <ReactSparkPopover toggleEl={this.renderToggle(styles)}>
                    <div
                        className={
                            this.props.hideImageSelector
                                ? 'background-picker background-picker--small'
                                : 'background-picker'
                        }
                    >
                        {this.state.error && (
                            <div className="spark-message spark-message--warning">
                                <i className="spark-message__icon spark-icon-alert-triangle spark-icon--fill"></i>
                                <p className="spark-message__content">
                                    <b>Background property is malformed.</b>
                                </p>
                            </div>
                        )}
                        <div className="row">
                            <div className={this.props.hideImageSelector ? 'col-xs-12' : 'col-xs-6'}>
                                <div className="background-picker--saturation">
                                    <Saturation
                                        {...this.state.backgroundColor}
                                        onChange={this.handleColorChange}
                                        {...optionalEvents}
                                    />
                                </div>
                                <div className="background-picker--controls">
                                    <div className="background-picker--hue">
                                        <Hue {...this.state.backgroundColor} onChange={this.handleColorChange} />
                                    </div>
                                    <div className="background-picker--alpha">
                                        <Alpha {...this.state.backgroundColor} onChange={this.handleColorChange} />
                                    </div>
                                </div>
                                {/*<div className="background-picker--editable-fields">
                                    <SketchFields
                                        {...this.state.backgroundColor}
                                        onChange={ this.handleColorChange }
                                        disableAlpha={ false }
                                    />
                                </div>*/}
                                <SketchPresetColors
                                    colors={this.props.preset}
                                    onClick={this.handleColorChange}
                                    {...optionalEvents}
                                />
                            </div>
                            {!this.props.hideImageSelector && (
                                <div className="col-xs-6">
                                    <div className="background-picker--image">
                                        <button
                                            type="button"
                                            style={styles.image}
                                            onClick={() => {
                                                this.setState({
                                                    showAssetBrowser: true
                                                });
                                            }}
                                        >
                                            <i className="spark-icon spark-icon-pictures spark-icon--lg"></i>
                                        </button>
                                    </div>
                                    <div className="row">
                                        <div className="col-xs-12">
                                            <button
                                                className="spark-btn--icon spark-icon spark-icon-close spark-tooltip"
                                                onClick={() => {
                                                    this.parser.clearImage();
                                                    this.readParser();
                                                    this.onChange();
                                                }}
                                            >
                                                <span className="spark-tooltip__content--top" role="tooltip">
                                                    Clear background
                                                    <span className="spark-tooltip__caret"></span>
                                                </span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                        <div className="row background-picker--advanced">
                            <InputTextField
                                style={{ width: '100%' }}
                                value={this.state.background}
                                onBlur={this.onChange}
                                onChange={this.rawInput}
                            />
                        </div>
                    </div>
                </ReactSparkPopover>
                <ModalAssetBrowser
                    store={store}
                    filter=".+\.(jpg|png|svg|jpeg|gif)$"
                    showButton={false}
                    category={CATEGORIES.IMAGE}
                    open={this.state.showAssetBrowser}
                    onOpen={value => this.setState({ showAssetBrowser: value })}
                    onClosed={value => this.setState({ showAssetBrowser: value })}
                    onSelect={this.onImageChange}
                />
            </div>
        );
    }
}
const mapStateToProps = state => {
    return {
        chainId: state.app.selected.chain.Id,
        hotelId: state.app.selected.selectedHotel.id,
        level: state.app.selected.level,
        assets: state.app.selected.assets
    };
};
export default connect(mapStateToProps)(BackgroundPicker);



// WEBPACK FOOTER //
// ./src/components/widgets/BackgroundPicker.js